import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import HeroBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'

import DemoForm from '@segment/templates/Forms/DemoForm'

import HeroImage from './HeroImage'

const copy = {
  overline: `CustomerAI Predictions`,
  heading: `Put the power of predictive AI in the hands of your marketer`,
  description: `Easily predict future customer behavior to deliver precise and personalized campaigns without needing to tap data science teams.`,
  buttonText: `Get a demo`,
}

const Hero: FC<PropsWithChildren<unknown>> = () => {
  return (
    <Wrapper>
      <HeroBase variant="2Col">
        <HeroRecipe.Copy>
          <CopyTextBase>
            <CopyText.Overline variant="overline" tag="span">
              {copy.overline}
            </CopyText.Overline>
            <CopyText.Heading variant="h1" tag="h1">
              {copy.heading}
            </CopyText.Heading>
            <CopyText.Description variant="pExtraLarge" tag="h2">
              {copy.description}
            </CopyText.Description>
          </CopyTextBase>
          <HeroRecipe.Form>
            <DemoForm
              isProgressive={true}
              customFormIdentifier="site-customerai-predictions-demo"
              customTrackingType="site-customerai-predictions-demo"
              successMessageAppearance="twilioLight"
            />
          </HeroRecipe.Form>
        </HeroRecipe.Copy>
        <HeroRecipe.Contents>
          <HeroImage />
        </HeroRecipe.Contents>
      </HeroBase>
    </Wrapper>
  )
}

const Wrapper = styled.header`
  position: relative;
  z-index: 0;
  background-color: ${({ theme }) => theme.palette.twilio.green[10]};
`

export default Hero
